import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../contexts/AppContext";
import confetti from "canvas-confetti";
import { Home, PartyPopper } from "lucide-react";
import SiteButton from "../components/SiteButton";
import RichText from "../components/RichText";

const fmt = (s) => `${(s || 0).toFixed(1)}s`;

export default function QuizComplete() {
  const navigate = useNavigate();
  const { t, settings } = useApp();
  const raw = sessionStorage.getItem("last_result");
  const result = raw ? JSON.parse(raw) : null;

  useEffect(() => {
    if (settings.confetti_enabled) {
      const duration = 2200;
      const end = Date.now() + duration;
      const colors = ["#FF6B6B", "#FFD93D", "#005F73", "#2D6A4F", "#FFFFFF"];
      (function frame() {
        confetti({ particleCount: 4, angle: 60, spread: 55, origin: { x: 0 }, colors });
        confetti({ particleCount: 4, angle: 120, spread: 55, origin: { x: 1 }, colors });
        if (Date.now() < end) requestAnimationFrame(frame);
      })();
    }
  }, [settings.confetti_enabled]);

  if (!result) {
    return (
      <div className="text-center pt-20">
        <button onClick={() => navigate("/")} className="px-6 py-3 rounded-full bg-[#0B1D3A] text-white">
          {t("quiz_complete_home")}
        </button>
      </div>
    );
  }

  return (
    <div className="max-w-xl mx-auto px-6 pt-10 pb-20 text-center" data-testid="quiz-complete-page">
      <span className="inline-flex h-20 w-20 items-center justify-center rounded-full bg-[#FFD93D] shadow-[0_8px_0_#B8860B] mb-6">
        <PartyPopper size={40} className="text-[#0B1D3A]" strokeWidth={2.5} />
      </span>
      <RichText k="quiz_complete_title" as="h1" className="font-fredoka text-4xl md:text-5xl font-bold text-[#0B1D3A] mb-3" />

      <div className="mt-8 grid grid-cols-1 gap-4">
        <div className="rounded-3xl bg-white p-5 border border-[#0B1D3A]/5 shadow-[0_8px_30px_-12px_rgba(11,29,58,0.15)]">
          <p className="font-nunito text-sm text-[#0B1D3A]/60 uppercase tracking-wide font-bold">
            {t("quiz_complete_time")}
          </p>
          <p className="font-fredoka text-3xl font-bold text-[#005F73] mt-1" data-testid="result-resolution">
            {fmt(result.resolution)}
          </p>
        </div>
        <div className="rounded-3xl bg-white p-5 border border-[#0B1D3A]/5 shadow-[0_8px_30px_-12px_rgba(11,29,58,0.15)]">
          <p className="font-nunito text-sm text-[#0B1D3A]/60 uppercase tracking-wide font-bold">
            {t("quiz_complete_penalties")}
          </p>
          <p className="font-fredoka text-3xl font-bold text-[#FF6B6B] mt-1" data-testid="result-penalty">
            +{fmt(result.penalty)}
          </p>
        </div>
        <div className="rounded-3xl bg-[#0B1D3A] p-6 text-white shadow-[0_10px_0_#020610]">
          <p className="font-nunito text-sm opacity-80 uppercase tracking-wide font-bold">
            {t("quiz_complete_final")}
          </p>
          <p className="font-fredoka text-5xl font-bold text-[#FFD93D] mt-1" data-testid="result-final">
            {fmt(result.final)}
          </p>
        </div>
      </div>

      <SiteButton onClick={() => navigate("/")} color="#1B5E3A" icon={Home} testId="complete-home-btn" fullWidth={false} className="mt-8">
        {t("quiz_complete_home")}
      </SiteButton>
    </div>
  );
}
